'use strict';

import util from './util';

var recaptcha = {
    /* source name, may only include "A-Za-z/_". Do not include user-specific information*/	
    source: {
        CONTACT_US: 'contactus',
    },

    getGoogleRecaptchaEnableStatus: function(source) {
        var isRecaptchaEnabled = SitePreferences.RECAPTCHA_ENABLED;
        
        if (!isRecaptchaEnabled) {
        	return false;
        }

        if (source === this.source.CONTACT_US) {
            isRecaptchaEnabled = SitePreferences.RECAPTCHA_FOR_CONTACTUS_ENABLED;
        } else {
            isRecaptchaEnabled = false;
        }

        return isRecaptchaEnabled;
    },
    
    generateRecaptchaToken: function(event, source, callbackFun) {
    	if (this.getGoogleRecaptchaEnableStatus(source) === true && SitePreferences.RECAPTCHA_SITE_KEY != null && typeof grecaptcha === 'object') {
    		event.preventDefault();
            event.stopPropagation();
    		grecaptcha.execute(SitePreferences.RECAPTCHA_SITE_KEY, {action: source}).then(callbackFun);
            return false;
    	}
    },
    
    /**
     * To use this function add the class 'contact-us-form' to the contactus form and 'contactus-submit' class to the submit button
     */
    initContactUsInvisibleRecaptcha: function() {
    	var isformSubmitted = false;
    	$('form.contact-us-form .contactus-submit').on('click', function(e) {
    		if (!$('form.contact-us-form').valid()) {
    			return false;
    		}

    		if (!isformSubmitted && this.getGoogleRecaptchaEnableStatus(recaptcha.source.CONTACT_US)) {
    			this.generateRecaptchaToken(e, recaptcha.source.CONTACT_US, function (token) {
    				var submitURL = util.appendParamToURL(Urls.customerServiceSubmit, 'captchaToken', token);
    				$.ajax({
    					url: util.appendParamToURL(submitURL, 'format', 'ajax'),
    					data: $('#ContactUsForm').serialize(),
    					method: 'POST',
    					aync: false
    				})
    				.done(function (response) {
    					if (response.status) {
    						isformSubmitted = true;
    						$('form.contact-us-form .contactus-submit').trigger('click');
    						return true;
    					} else {
    						return false;
    					}
    				});
    			});
    		} else {
    			isformSubmitted = false
    		}
    	});
    },
	
    displayRecaptchaError: function(msg) {
        if($('.grecaptcha-badge').length > 0  && !$('.send-contact-us').hasClass('invalidrecaptcha')) {
            var $errEle = $('<div class="grecaptcha-error">' + '' + '</div>');
            $errEle.html(msg).insertBefore('.send-contact-us');
            $('.send-contact-us').addClass('invalidrecaptcha'); 
        }
    }
};

export default recaptcha;
